import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectModalType, selectModalProps } from "./rootModalSlice";
import { RootState } from "store/rootReducer";
import { CheckoutModal, CheckoutSuccessModal } from "./modals";
import FiltersModal from "features/Filters/FiltersModal";
import { useLocation } from "react-router-dom";

type keyComponent = {
  [key: string]: any;
};
const MODAL_COMPONENTS: keyComponent = {
  CHECKOUT: CheckoutModal,
  CHECKOUT_SUCCESS: CheckoutSuccessModal,
  FILTERS: FiltersModal,
};

const RootModal = () => {
  const modalType = useSelector((state: RootState) => selectModalType(state));
  const modalProps = useSelector((state: RootState) => selectModalProps(state));
  const location = useLocation();

  const isSitemap = location.pathname?.includes("sitemap");
  const isLogin = location.pathname?.includes("asparuh");
  let root = document.body;

  useEffect(() => {
    document.body.style.overflowX = "hidden";
    return () => {
      document.body.style.overflowX = "scroll";
    };
  }, []);

  if (!modalType) {
    root.classList.remove("no-scroll");
    return null;
  } else {
    root.classList.add("no-scroll");
  }

  const SpecificModal = MODAL_COMPONENTS[modalType];
  if (isSitemap || isLogin) return null;

  return <SpecificModal {...modalProps} />;
};

export default RootModal;
